export const DEFAULT_TITLE = 'Autodesk Construction Cloud';

export const SCROLL_CONTAINER_ID = 'scroll-to-top'; //taken from project list providers remote

export const EXO_SKELETON_SCOPE_NAME = 'ACCExoSkeleton';

export const RETRY_IMPORT_REMOTE = 'retry-import-remote';
export const RETRY_IMPORT_REMOTE_FAILURE = 'retry-import-remote-failure';
export const MFA_BANNER_SESSION_STORAGE_KEY = 'mfa-setup-banner';
